import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34380664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import {ref} from "vue";
import MyOfficeAssetTab from "@/views/ViewsComponents/officeAssets/MyOfficeAssetTab.vue";
import MyTaskOfficeAssetTab from "@/views/ViewsComponents/officeAssets/MyTaskOfficeAssetTab.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeTab = ref<string>("我领用的")

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      type: "border-card",
      class: "tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "我领用的",
          name: "我领用的"
        }, {
          default: _withCtx(() => [
            _createVNode(MyOfficeAssetTab, { type: "我领用的" })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "我管理的",
          name: "我管理的",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(MyOfficeAssetTab, { type: "我管理的" })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "盘点领用资产",
          name: "盘点领用资产",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(MyTaskOfficeAssetTab, {
              type: "我领用的",
              "type-is-my-manager": false
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "盘点管理资产",
          name: "盘点管理资产",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(MyTaskOfficeAssetTab, {
              type: "我管理的",
              "type-is-my-manager": true
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})